(function () {
  // UK bank holidays (England & Wales). Update this list every year.
  var BANK_HOLIDAYS = [
    '2026-01-01', '2026-04-03', '2026-04-06', '2026-05-04',
    '2026-05-25', '2026-08-31', '2026-12-25', '2026-12-28',
    '2027-01-01'
  ];

  function dateKey(d) { return d.toISOString().split('T')[0]; }

  function isWorkingDay(d) {
    var day = d.getDay();
    if (day === 0 || day === 6) return false;
    if (BANK_HOLIDAYS.indexOf(dateKey(d)) !== -1) return false;
    return true;
  }

  function addWorkingDays(start, days) {
    var d = new Date(start);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (isWorkingDay(d)) added++;
    }
    return d;
  }

function formatDate(d) {
  var weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return weekdays[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()];
}

  function nextCutoff(now, cutoffHour) {
    var c = new Date(now);
    c.setHours(cutoffHour, 0, 0, 0);
    if (now >= c || !isWorkingDay(now)) {
      do { c.setDate(c.getDate() + 1); } while (!isWorkingDay(c));
      c.setHours(cutoffHour, 0, 0, 0);
    }
    return c;
  }

  function render(el) {
    var processingDays = parseInt(el.dataset.processingDays, 10) || 3;
    var cutoffHour = parseInt(el.dataset.cutoffHour, 10);
    if (isNaN(cutoffHour)) cutoffHour = 12;
    var showCountdown = el.dataset.showCountdown === 'true';
    var cutoffTextEl = el.querySelector('.estimated-delivery__cutoff-text');
    var standardDateEl = el.querySelector('.estimated-delivery__standard-date');
    var expressDateEl = el.querySelector('.estimated-delivery__express-date');

    function missedCutoffNow(now) {
      var c = new Date(now); c.setHours(cutoffHour, 0, 0, 0);
      return now >= c || !isWorkingDay(now);
    }

    function dateFor(now, transitDays, missed) {
      return addWorkingDays(now, processingDays + transitDays + (missed ? 1 : 0));
    }

    function update() {
      var now = new Date();
      var missed = missedCutoffNow(now);

 var cutoffRow = el.querySelector('.estimated-delivery__cutoff');
if (showCountdown && !missed) {
  cutoffRow.style.display = '';
  var cutoff = nextCutoff(now, cutoffHour);
  var diffMs = cutoff - now;
  var h = Math.floor(diffMs / 3600000);
  var m = Math.floor((diffMs % 3600000) / 60000);
  cutoffTextEl.textContent = 'Order within ' + h + 'h ' + m + 'm to begin processing today';
} else {
  cutoffRow.style.display = 'none';
}

     if (standardDateEl) {
  var sDays = parseInt(standardDateEl.dataset.transitDays, 10) || 0;
  standardDateEl.textContent = 'Est. arrival ' + formatDate(dateFor(now, sDays, missed));
}
if (expressDateEl) {
  var eDays = parseInt(expressDateEl.dataset.transitDays, 10) || 0;
  expressDateEl.textContent = 'est. arrival ' + formatDate(dateFor(now, eDays, missed));
}
    }

    update();
    setInterval(update, 60000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.estimated-delivery').forEach(render);
  });
})();